export default "__VITE_ASSET__2712ff17__"